import { useState } from 'react';

function DishyearsData() {
    const [clicked, openClicked] = useState(null);

    const accordionClick = (index) => {
      if (clicked === index) {
        return openClicked(null);
      }
  
      openClicked(index);
    }

    return (
        <div>
            {data.map((dish, index) => (
                <div key={dish.id} className="dish__bg">
                    
                    <div className={`dish__cursor dish__bg--${dish.color}`} onClick={() => accordionClick(index)}>
                        <div className="container flex dish__bar">
                            <div className="flex dish__title-bar">
                                <img src={dish.icon} className="dish__icon" alt={dish.iconName}/>
                                <h2 className="dish__title">{dish.name}</h2>
                            </div>
            
                            <div className={`dish__button ${clicked === index ? 'dish__button--clicked' : ''}`} aria-label="drop down button"></div>
                        </div>
                    </div>
                    
                    <div className={`dish dish__border-top dish__bg--light-${dish.color} + ${clicked === index ? ' dish--visible' : ''}`}>
                        <div className="container container--dish top-bottom--dish flex--dish">
                            <div className="width--hundred dish__png">
                                <img src={dish.png} className="dish__br" alt={dish.name}/>
                            </div>
                            
                            <div className="dish__content width--hundred">
                                <h1 className="dish__name">{dish.name}</h1>
                                <div className="dish__br">
                                    <div className="flex">
                                        <img src="img/icon-silverware.svg" className="dish__content-icon" alt="silverware"/>
                                        <p className="dish__info">{dish.restaurant}</p>
                                    </div>
                
                                    <div className="flex">
                                        <img src="img/icon-camera.svg" className="dish__content-icon" alt="camera"/>
                                        <p className="dish__info">{dish.year}</p>
                                    </div>
                                </div>
                                <p className="dish__p dish__br">{dish.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

const data = [
  {
    id: 1,
    color: 'yellow',
    icon: 'img/food-svg/tomato.svg',
    iconName: 'tomato',
    png: 'img/food-png/umami-chicken.png',
    name: 'Umami Chicken',
    restaurant: 'The Fat Cow',
    year: 2016,
    description: 'I love chicken and risotto which is why I love this dish. I also like the honey glaze as its sweetness complements the savory taste of the risotto and chicken. I miss this dish. The last time I went to Fat Cow in 2021, I no longer saw this in their menu. Their Umami Chicken was one of the first things I ordered when trying out The Fat Cow and it was one of the reasons why I kept coming back.'
  },
  {
    id: 2,
    color: 'orange',
    icon: 'img/food-svg/hand.svg',
    iconName: 'hand',
    png: 'img/food-png/hands-of-stone.png',
    name: 'Hands of Stone',
    restaurant: 'Red Corner',
    year: 2017,
    description: 'I love the burger and fries combination which is why you’ll tend to see me order this dish from Red Corner. My all-time favorite dish in Red Corner is the Hands of Stone, mainly because of the country-fried bacon.'
  },
  {
    id: 3,
    color: 'red',
    icon: 'img/food-svg/cheese.svg',
    iconName: 'cheese',
    png: 'img/food-png/three-cheese.png',
    name: 'Three Cheese Fondue Poppers',
    restaurant: 'The Bright Side',
    year: 2017,
    description: 'I love cheese and I love shrimps and chicken, making this dish enjoyable to eat.'
  },
  {
    id: 4,
    color: 'yellow',
    icon: 'img/food-svg/shrimp.svg',
    iconName: 'shrimp',
    png: 'img/food-png/shrimp.png',
    name: 'Shrimp Katsu Set',
    restaurant: 'Katsu Country',
    year: 2017,
    description: 'If this wasn’t the first time I’ve eaten in Katsu Country, this was definitely one of the earliest times I’ve eaten there. The Katsu Set comes with cabbage salad which is seen sitting beside the shrimps. It also comes with rice which is in a pink bowl located behind the plate of shrimps and the miso soup is in a black bowl situated on the right side of the image. The said set became my go-to meal in Katsu Country until I started liking the Pork Tenderloin Katsu Set better. Never was I ever not full after eating in Katsu Country. Thus, if you want to only order one order, but don’t want to get easily "sawa" with the meal, definitely order one of Katsu Country’s Katsu Sets.'
  },
  {
    id: 5,
    color: 'green',
    icon: 'img/food-svg/waffles.svg',
    iconName: 'waffle',
    png: 'img/food-png/waffles.png',
    name: 'Waffle Foldover',
    restaurant: 'Pancake House',
    year: 2018,
    description: 'Sometimes, after my family would have Sunday lunch, we would dine in Pancake House for dessert. I would usually order their regular waffles. However, on that certain day, I felt like I want to try something different. As a result, I ordered the Waffle Foldover which is a vanilla ice cream, chocolate syrup, and sprinkles of button-shaped chocolate inside a folded waffle. Eating the Waffle Foldover made me feel like a child again since it is similar with the desserts I enjoyed back in the day. Recently, when I checked Pancake House’s website, the Waffle Foldover is nowhere to be found.'
  }
]

export default DishyearsData;